import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  ResetAuditTrailDrawerState,
  SetAuditTrailDrawerCurrentShiftIdState,
  SetAuditTrailDrawerOpenState,
} from './audit-trail-drawer.action';

export interface AuditTrailDrawerStateModel {
  isOpen: boolean;
  currentShiftId: string;
}

const defaultAuditTrailDrawerState: AuditTrailDrawerStateModel = {
  isOpen: false,
  currentShiftId: '',
};

@State<AuditTrailDrawerStateModel>({
  name: 'AuditTrailDrawerState',
  defaults: defaultAuditTrailDrawerState,
})
@Injectable()
export class AuditTrailDrawerState {
  @Selector()
  static isOpen(state: AuditTrailDrawerStateModel): boolean {
    return state.isOpen;
  }

  @Selector()
  static currentShiftId(state: AuditTrailDrawerStateModel): string {
    return state.currentShiftId;
  }

  @Action(ResetAuditTrailDrawerState)
  resetAuditTrailDrawerState({
    setState,
  }: StateContext<AuditTrailDrawerStateModel>) {
    setState(defaultAuditTrailDrawerState);
  }

  @Action(SetAuditTrailDrawerOpenState)
  setAuditTrailDrawerOpenState(
    { patchState }: StateContext<AuditTrailDrawerStateModel>,
    action: SetAuditTrailDrawerOpenState,
  ) {
    patchState({
      isOpen: action.openStatus,
    });
  }

  @Action(SetAuditTrailDrawerCurrentShiftIdState)
  setAuditTrailDrawerCurrentShiftIdState(
    { patchState }: StateContext<AuditTrailDrawerStateModel>,
    action: SetAuditTrailDrawerCurrentShiftIdState,
  ) {
    patchState({
      currentShiftId: action.currentShiftId,
    });
  }
}
